// extracted by mini-css-extract-plugin
module.exports = {"quantity_counter":"quantityCounter_quantity_counter__2v7cv","button":"quantityCounter_button__2wW2H","input":"quantityCounter_input__32xrW"};